(function () {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('iris', {
            parent: 'app',
            url: '/iris',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/portal/iris/iris.html',
                    controller: 'IrisController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]//,
                // irisRelease: ['GithubIrisRelease', function (GithubIrisRelease) {
                //     return GithubIrisRelease.get({id: 'latest'}).$promise;
                // }]
            }
        });
    }
})();
